<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div class="modal-body">
      <header class="text-center pb-4">
        <h3
          class="my-0 text-2xl font-bold"
          v-text="'Refund Payment'"
        />
      </header>
      <section class="mx-6">
        <div class="field__label flex items-center justify-between">
          <div class="field__label flex items-center justify-between">
            <label
              class="field__label__text block text-xs mb-2"
              for="reason"
              v-text="'Reason'"
            />
          </div>
          <ErrorMessage
            v-if="form.errors.has('reason')"
            :error="form.errors.get('reason')"
          />
        </div>
        <select
          id="reason"
          v-model="form.reason"
          name="reason"
        >
          <option
            v-for="(item, key) of refundReasons"
            :key="key"
            :selected="form.reason === key"
            :value="key"
            v-text="item"
          />
        </select>
      </section>
      <div class="modal-footer text-center mt-8">
        <button
          type="button"
          class="btn"
          @click="requestRefund"
          v-text="'Submit'"
        />
        <button
          type="button"
          class="btn btn--sm btn--danger ml-4 "
          @click="close"
          v-text="'Cancel'"
        />
      </div>
    </div>
  </BaseModal>
</template>

<script type="text/babel">
import { mapActions } from 'vuex'
import Form from 'Base/Resources/assets/js/plugins/Form'
import ErrorMessage from 'FormBuilder/Resources/assets/js/components/inputs/ErrorMessage'

export default {
  name: 'CreateRefundModal',
  components: {
    ErrorMessage,
  },
  props: {
    payment: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
    refundReasons: {
      type: Object,
      required: false,
      default: () => ({
        requested_by_customer: 'Requested By Member',
        duplicate: 'Duplicate',
        fraudulent: 'Fraudulent',
      }),
    },
  },
  data() {
    return {
      form: new Form({
        reason: 'requested_by_customer',
      }),
    }
  },
  methods: {
    ...mapActions([
      'paymentsCreateRefund',
      'paymentGetPayments',
    ]),
    requestRefund() {
      const vm = this

      this.paymentsCreateRefund({
        paymentUuid: this.payment.uuid,
        params: this.form,
      }).then(() => {
        this.close()

        this.$emit('refundCreated')
      }).catch((errors) => {
        vm.form.setErrors(errors.response.data)

        vm.$store.commit('baseAddNotification', {
          type: 'error',
          title: 'Error',
          text: (vm.form.errors.message),
        })
      })
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
